import posthog from "posthog-js";

const token = import.meta.env.VITE_POSTHOG_TOKEN as string;
const host = import.meta.env.VITE_POSTHOG_HOST as string;

export function initPostHog() {
  if (!token) return;
  posthog.init(token, {
    api_host: host,
    defaults: "2026-01-30",
    capture_exceptions: true,
    autocapture: true,
    capture_pageview: true,
  });
}

export function captureException(error: unknown, context?: Record<string, unknown>) {
  if (!token) return;
  posthog.captureException(error, context);
}

export default posthog;
